export default "__VITE_ASSET__Cg3yY9tH__"